var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVerifyUser(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.3 11.25L3.35 9.65L1.55 9.25L1.725 7.4L0.5 6L1.725 4.6L1.55 2.75L3.35 2.35L4.3 0.75L6 1.475L7.7 0.75L8.65 2.35L10.45 2.75L10.275 4.6L11.5 6L10.275 7.4L10.45 9.25L8.65 9.65L7.7 11.25L6 10.525L4.3 11.25ZM5.475 7.775L8.3 4.95L7.6 4.225L5.475 6.35L4.4 5.3L3.7 6L5.475 7.775Z",
    fill: "#2BC804"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifyUser);
export default __webpack_public_path__ + "static/media/verify-user.d0fca34d9dac791226a8b43bd9ecd353.svg";
export { ForwardRef as ReactComponent };